module.exports = __webpack_public_path__ + "static/media/carousel-white.e3a23e27.png";